import { request, getAdminAPIPath } from '../../../api/core';

export const sendMessageRequest = (message: any) => request(getAdminAPIPath('messages'), {
  method: 'POST',
  data: message,
});
